// extracted by mini-css-extract-plugin
export default {"form-card":"ShoolAdminTip_form-card__cUP6N","form-title":"ShoolAdminTip_form-title__rNPdH","form-actions":"ShoolAdminTip_form-actions__1Khwd"};